import useRequest from "@/utils/useReq";
import { CheckOutlined } from "@ant-design/icons";
import { Button, Radio } from "antd";
import classNames from "classnames";
import { useState } from "react";
import { Case, Switch } from "react-if";
import { createPin, delCover, getBoardPins, setCover } from "../../../services";
import imageUrl from "../../../utils/imageUrl";
import HBList from "../../HBList";
import HBMessage from "../../HBMessage";
import Image from "../../Image";
import styles from "../form.module.less";
import UploadCover from "./UploadCover";
/**
 * 设置封面视图
 */
const TYPE = {
  default: 1, // 默认封面
  diy: 2, //自定义封面
  upload: 3, //本地上传
};
const btnText = {
  1: "默认",
  2: "自定义",
  3: "本地上传",
};
export function SettingCover({
  cover,
  value,
  boardTitle,
  boardId,
  onOk,
  onCancel,
}) {
  const [current, setCurrent] = useState(
    value ? (cover?.uploaded ? TYPE.upload : TYPE.diy) : TYPE.default
  );
  const [selected, setSelected] = useState(value);
  const [max, setMax] = useState(undefined);
  const [hasMore, setHasMore] = useState(true);
  const [coverImg, setCoverImg] = useState({
    syncBoard: false,
    ossFile: current === TYPE.upload ? cover?.file : undefined,
  });

  const pins = useRequest(
    async () => {
      const data = await getBoardPins({
        board_id: boardId,
        limit: 12,
        max,
      });

      if (data.err) return pins.data;

      if (data.pins.length < 12) {
        setHasMore(false);
      }

      if (!pins.data) return data.pins;
      else return [...pins.data, ...data.pins];
    },
    {
      refreshDeps: [max, boardId],
    }
  );

  // if (pins.loading) return null;

  const renderItem = (el, index) => {
    return (
      <CoverSelect
        key={index}
        selected={el.pin_id === selected}
        file={el.file}
        onClick={() => {
          setSelected(el.pin_id);
        }}
      />
    );
  };

  const onLoadMore = () => {
    const last = pins.data[pins.data.length - 1];
    setMax(last.seq_id || last.pin_id);
  };
  const diyUploadCover = async () => {
    const { syncBoard, ossFile } = coverImg;
    let result;
    // 如果有图片信息但是没有图片id则直接退出,相当于用户没有修改图片
    if (ossFile && !ossFile.id) {
      onCancel && onCancel();
      return;
    }
    if (!ossFile || !ossFile?.id) {
      HBMessage.info("请先上传封面");
      return;
    }
    // 判断是否需要同步到画板内

    if (syncBoard) {
      result = await createPin({
        board_id: boardId,
        file_id: ossFile.id,
        set_cover: true,
      });
    } else {
      result = await setCover({
        board_id: boardId,
        file_id: ossFile.id,
      });
    }
    if (!result?.err) {
      HBMessage.success("成功设置画板封面");
      onOk();
    }
  };
  const saveFn = async function () {
    if (current === TYPE.default) {
      const { err } = await delCover({
        board_id: boardId,
      });
      if (!err) {
        HBMessage.success("成功设置画板封面");
        onOk();
      }
    } else if (current === TYPE.upload) {
      diyUploadCover();
    } else {
      if (selected) {
        const { err } = await setCover({
          board_id: boardId,
          pin_id: selected,
        });
        if (!err) {
          HBMessage.success("成功设置画板封面");
          onOk();
        }
      } else {
        HBMessage.info("请先选择封面");
      }
    }
  };

  return (
    <div className={styles.coversetting}>
      <Radio.Group
        defaultValue={current}
        onChange={(e) => {
          setCurrent(e.target.value);
        }}
      >
        <Radio value={TYPE.default}>默认使用封面图（最新采集）</Radio>
        <Radio value={TYPE.diy}>使用自定义封面</Radio>
        <Radio value={TYPE.upload}>本地上传封面</Radio>
      </Radio.Group>
      <Switch>
        <Case condition={current == 2}>
          <div
            className={styles.wrap}
            id="cover-select-wrap"
            style={{ minHeight: "336px" }}
          >
            <HBList
              hasMore={hasMore}
              disableMasonry={true}
              render={renderItem}
              dataSource={pins.data}
              onLoadMore={onLoadMore}
              scrollableTarget="cover-select-wrap"
              endMessage={null}
            />
          </div>
        </Case>
        <Case condition={current == 3}>
          <UploadCover
            coverImg={coverImg}
            setCoverImg={setCoverImg}
            boardTitle={boardTitle}
          ></UploadCover>
        </Case>
      </Switch>

      <div style={{ textAlign: "right", margin: "24px 24px 0 0" }}>
        <Button
          type="text"
          style={{ marginRight: "8px" }}
          onClick={() => {
            onCancel && onCancel();
          }}
        >
          取消
        </Button>
        <Button
          type="primary"
          onClick={saveFn}
          data-gd-click={"button_click"}
          data-button-name={`设置封面_${btnText[current]}`}
        >
          保存配置
        </Button>
      </div>
    </div>
  );
}

/**
 * 选择
 * @param {*} props
 * @returns
 */
function CoverSelect(props) {
  const { file } = props;
  const url = imageUrl(file, { width: 240 });
  return (
    <div
      className={classNames(styles.item, { [styles.selected]: props.selected })}
      onClick={props.onClick}
    >
      <Image
        className="transparent-img-bg"
        src={url}
        alt="设置封面图"
        width="156"
        height="156"
      />
      <CheckRadio selected={props.selected} />
    </div>
  );
}

// 封面图勾选单选框
function CheckRadio(props) {
  return (
    <div
      className={`${styles.checkradio} ${
        props.selected ? styles.selected : ""
      }`}
    >
      <CheckOutlined />
    </div>
  );
}

export function CoverImg({ board, onClick }) {
  /** 背景图片 */
  let coverImg;
  if (board.cover) {
    coverImg = imageUrl(board.cover.file, { width: 240 });
  } else if (board.pins?.length) {
    coverImg = imageUrl(board.pins[0].file, { width: 240 });
  }
  if (coverImg) {
    return (
      <div className={styles.coverImg}>
        {coverImg ? (
          <div className={styles.imgwrap}>
            <Image
              className="transparent-img-bg"
              src={coverImg}
              alt="修改封面"
              height="120"
              width="120"
            />
          </div>
        ) : (
          <div className={styles.blank}></div>
        )}
        <Button onClick={onClick}>修改封面</Button>
      </div>
    );
  } else {
    return null;
  }
}
